import { render, staticRenderFns } from "./CommunityCompanySanjaeCard.vue?vue&type=template&id=ab127c2c&scoped=true"
import script from "./CommunityCompanySanjaeCard.vue?vue&type=script&lang=js"
export * from "./CommunityCompanySanjaeCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityCompanySanjaeCard.vue?vue&type=style&index=0&id=ab127c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab127c2c",
  null
  
)

export default component.exports